import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeedService {
  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  
  CommentLoad(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_PostCommentMaster_Load/Get`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  CommentInsert(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `PostCommentMaster/Insert`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  LikeInsert(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_PostLikeMaster_Insert/Update`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  LikeLoad(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_PostLikeMaster_Load/Get`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  PostLoad(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_PostMaster_Load/Get`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  InsertPost(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `PostMaster_Insert/Update`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  BirthDayDetails(Detail: any) {
    return this.http.post<any>(environment.API_URL + `GetEmployeesBy/BirthMonth`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  
}
